import { useTranslation } from "react-i18next";

import { TableHeader } from "@/components/Layout/Table/TableHeader/TableHeader";
import { SortableHeaderCell } from "@/components/Layout/Table/TableSortButton/TableSortButton";
import { BillSelectAllCheckbox } from "@/components/Portal/Documents/BillList/components/BillSelectAllCheckbox/BillSelectAllCheckbox";
import { GetDrBillsForCustomerSortField } from "@/services/model";
import { NamespaceKey } from "@/utils/translationKey";

/** `portal` keys for the sortable columns, in display order. */
const columns: {
  titleKey: NamespaceKey<"portal">;
  sortField: GetDrBillsForCustomerSortField;
}[] = [
  {
    titleKey: "bills.list.tableHeaders.date",
    sortField: GetDrBillsForCustomerSortField.Datum,
  },
  {
    titleKey: "bills.list.tableHeaders.invoiceFor",
    sortField: GetDrBillsForCustomerSortField.Abrechnungsmonat,
  },
  {
    titleKey: "bills.list.tableHeaders.number",
    sortField: GetDrBillsForCustomerSortField.Rechnungsnummer,
  },
  {
    titleKey: "bills.list.tableHeaders.amount",
    sortField: GetDrBillsForCustomerSortField.Betrag,
  },
  {
    titleKey: "common.device.attributes.status",
    sortField: GetDrBillsForCustomerSortField.Status,
  },
];

// this is the table header row for the invoices list
export const BillListHeader = ({
  currentPageBillIds,
  isSelecting,
}: {
  currentPageBillIds: number[];
  isSelecting?: boolean;
}) => {
  const { t } = useTranslation("portal");

  return (
    <TableHeader>
      {columns.map(({ titleKey, sortField }) => (
        <SortableHeaderCell
          key={sortField}
          title={t(titleKey)}
          sortField={sortField}
        />
      ))}
      {/* The trailing column swaps per state: the checkbox column takes the
          place of "Öffnen" while selecting, so the five data columns keep
          sharing the remaining width evenly. */}
      {isSelecting ? (
        <th className="bill-selection">
          <BillSelectAllCheckbox currentPageBillIds={currentPageBillIds} />
        </th>
      ) : (
        <th>{t("bills.list.tableHeaders.open")}</th>
      )}
    </TableHeader>
  );
};
